export default __webpack_public_path__ + "static/media/top.141d93b6.png";